const WebAdminRouter = [
    {
        path: '',
        redirect: 'classify'
    },
    {
        path: 'member',
        meta: {
            title: '员工管理',
            needLogin: true,
        },
        component: () =>
            import ('../../views/web/page/member/index'),
    },
    {
        path: 'dept',
        meta: {
            title: '部门管理',
            needLogin: true,
        },
        component: () =>
            import ('../../views/web/page/dept/index'),
    },
    {
        path: 'card/classify',
        meta: {
            title: '内容管理',
            needLogin: true,
        },
        component: () =>
            import ('../../views/web/page/info/list'),
    },
    {
        path: 'card/edit/:id',
        meta: {
            title: '编辑',
            needLogin: true,
        },
        component: () =>
            import ('../../views/web/page/info/edit'),
    },
    {
        path: 'message',
        meta: {
            title: '消息中心',
            needLogin: true,
        },
        component: () =>
            import ('../../views/web/page/message/list'),
    },
    {
        path: 'feedback',
        meta: {
            title: '意见反馈',
            needLogin: true,
        },
        component: () =>
            import ('../../views/web/page/feedback'),
    },
]
export default WebAdminRouter